import { render, staticRenderFns } from "./Desktop.vue?vue&type=template&id=354c55fa&"
import script from "./Desktop.vue?vue&type=script&lang=ts&"
export * from "./Desktop.vue?vue&type=script&lang=ts&"
import style0 from "./Desktop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports